import { createSvgIcon } from '@mui/material/utils';

export const SplitCell = createSvgIcon(
  <g>
    <g clipPath="url(#clip0_9077_58)">
      <path d="M24 0H0V24H24V0Z" fillOpacity="0.01" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 3V7C3 7.55228 2.55228 8 2 8C1.44772 8 1 7.55228 1 7V2.5C1 1.67158 1.67158 1 2.5 1H9.5C10.3284 1 11 1.67159 11 2.5V21.5C11 22.3284 10.3284 23 9.5 23H2.5C1.67159 23 1 22.3284 1 21.5V17C1 16.4477 1.44772 16 2 16C2.55228 16 3 16.4477 3 17V21H9V3H3Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 3V21H21V17C21 16.4477 21.4477 16 22 16C22.5523 16 23 16.4477 23 17V21.5C23 22.3284 22.3284 23 21.5 23H14.5C13.6716 23 13 22.3284 13 21.5V2.5C13 1.67159 13.6716 1 14.5 1H21.5C22.3284 1 23 1.67159 23 2.5V7C23 7.55228 22.5523 8 22 8C21.4477 8 21 7.55228 21 7V3H15Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 11.9992C13.0005 11.4469 13.4485 10.9995 14.0008 11L22.0008 11.0066C22.5531 11.0071 23.0005 11.4551 23 12.0074C22.9995 12.5597 22.5515 13.0071 21.9992 13.0066L13.9992 13C13.4469 12.9995 12.9995 12.5515 13 11.9992Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 11.9992C11.0005 12.5515 10.5531 12.9995 10.0008 13L2.00083 13.0066C1.44854 13.0071 1.00046 12.5597 1 12.0074C0.999545 11.4551 1.44689 11.0071 1.99917 11.0066L9.99918 11C10.5515 10.9995 10.9995 11.4469 11 11.9992Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.9066 8.90888C19.2972 8.51835 19.9303 8.51833 20.3209 8.90884L22.7074 11.2953C23.0979 11.6858 23.0979 12.319 22.7074 12.7095L20.3209 15.096C19.9304 15.4865 19.2972 15.4865 18.9067 15.096C18.5161 14.7055 18.5161 14.0723 18.9067 13.6818L19.7022 12.8863L20.5861 12.0024L19.7022 11.1185L18.9067 10.3231C18.5161 9.93258 18.5161 9.29942 18.9066 8.90888Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.0848 8.91301C5.47533 9.30353 5.47533 9.9367 5.08481 10.3272L3.40543 12.0066L5.08481 13.686C5.47533 14.0765 5.47533 14.7097 5.0848 15.1002C4.69428 15.4907 4.06111 15.4907 3.67059 15.1002L1.2841 12.7137C1.09657 12.5261 0.991209 12.2718 0.991211 12.0066C0.991213 11.7413 1.09657 11.487 1.28411 11.2995L3.67059 8.91301C4.06111 8.52249 4.69427 8.52248 5.0848 8.91301Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_9077_58">
        <rect width="24" height="24" />
      </clipPath>
    </defs>
  </g>,

  'splitCell',
);
